function matchMediaQuery(mediaQueries: string[]): boolean {
  return window.matchMedia(['only screen', ...mediaQueries.map((res) => `(${res})`)].join(' and ')).matches;
}

function remCalc(pixels: number): string {
  return `${pixels / 16}rem`;
}

const mediaQuery = {
  isSmallOnly(): boolean {
    return matchMediaQuery([`max-width: ${remCalc(767)}`]);
  },
  isMediumUp(): boolean {
    return matchMediaQuery([`min-width: ${remCalc(768)}`]);
  },
  isMediumOnly(): boolean {
    return matchMediaQuery([`min-width: ${remCalc(768)}`, `max-width: ${remCalc(1023)}`]);
  },
  isLargeUp(): boolean {
    return matchMediaQuery([`min-width: ${remCalc(1024)}`]);
  },
  isLargeOnly(): boolean {
    return matchMediaQuery([`min-width: ${remCalc(1024)}`, `max-width: ${remCalc(1199)}`]);
  },
  isXLargeUp(): boolean {
    return matchMediaQuery([`min-width: ${remCalc(1200)}`]);
  },
  isXLargeOnly(): boolean {
    return matchMediaQuery([`min-width: ${remCalc(1200)}`, `max-width: ${remCalc(2799)}`]);
  },
  isXXLargeUp(): boolean {
    return matchMediaQuery([`min-width: ${remCalc(2800)}`]);
  },
  isPortrait(): boolean {
    return matchMediaQuery(['orientation: portrait']);
  },
  isLandscape(): boolean {
    return matchMediaQuery(['orientation: landscape']);
  },
  getBreakpoint(): string {
    const breakpoints = {
      small: this.isSmallOnly,
      medium: this.isMediumOnly,
      large: this.isLargeOnly,
      xLarge: this.isXLargeOnly,
      xxLarge: this.isXXLargeUp
    };

    return Object.keys(breakpoints).reduce((breakpoint, key): string => {
      if (breakpoints[key]()) {
        breakpoint = key;
      }

      return breakpoint;
    });
  },
  rolexGlobal: {
    isSmallOnly(): boolean {
      return matchMediaQuery([`max-width: ${remCalc(767)}`]);
    },
    isLargeUp(): boolean {
      return matchMediaQuery([`min-width: ${remCalc(1069)}`]);
    },
    isXLargeUp(): boolean {
      return matchMediaQuery([`min-width: ${remCalc(1069)}`]);
    }
  }
};

export default mediaQuery;
